<script setup>
import { useReadyReports, clearReadyReports } from '@/composables/useReadyReports.js'

const emit = defineEmits(['resolve'])
const state = useReadyReports()

const close = () => {
  clearReadyReports()
  emit('resolve', null)
}
</script>

<template>
  <ImoModal_ @close="close" size="sm" title="Relatório Pronto" :closeOnBackdrop="false">
    <template #body>
      <div class="flex flex-col items-center justify-center px-6 py-6 text-center">
        <ImoIcon name="tick-circle" :size="64" class="text-success-60 mb-4" />
        <p v-if="state.reports.length === 1" class="text-neutral-80 text-sm">
          Seu relatório foi gerado com sucesso. Clique abaixo para acessar seu relatório.
        </p>
        <p v-else class="text-neutral-80 text-sm">
          Seus relatórios foram gerados com sucesso. Clique abaixo para acessá-los.
        </p>
      </div>
    </template>
    <template #footer>
      <div class="flex w-full flex-col gap-3 px-4 py-2">
        <a
          v-for="(report, index) in state.reports"
          :key="index"
          :href="report.pdfUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="w-full"
        >
          <ImoButton :text="report.name" size="sm" variant="primary" class="w-full" />
        </a>
        <ImoButton @click="close" text="Fechar" size="sm" variant="tertiary" class="w-full" />
      </div>
    </template>
  </ImoModal_>
</template>
